import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CustomerSelectionModal from "./CustomerSelectionModal";
import PartSelectionModal from "./PartSelectionModal";
import CustomerService from "../../../Customer/Controller/CustomerController";
import CustomerContactService from "../../../Customer/Controller/CustomerContactController";
import CustomerSiteService from "../../../Customer/Controller/CustomerSiteController";
import AgreementService from "../../Controller/AgreementController";
import QuotationService from "../../../Quotation/Controller/QuotationController";
import ContractFrequency from "../../../Setup/controller/ContractFrequencyController/ContractFrequencyController";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
import { handleChange, handleSubmit } from "../../Controller/CreateAgreementController";

import VatTaxService from '../../../Setup/controller/VatTaxController/VatTaxController';
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import CurrencyTextField from "../../../Jobs/View/JobForms/CurrencyTextField";
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
import useSaleOrder from "./useSaleOrder";
import useInvoice from "./useInvoice";
import CustomerDiscountService from "../../../Customer/Controller/CustomerDiscountController";
import CustomerCategoryDiscountService from "../../../Customer/Controller/CustomerCategoryDiscountController"
import CustomerStockService from "../../../Customer/Controller/CustomerStockController";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import DescriptionModal from "../../../SaleOrder/View/SaleOrderForms/DescriptionModal";
import LeadUserDefineFieldsSection from '../../../Lead/Views/LeadForms/LeadUserDefineFieldsSection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";

import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from "../../../../config/config";
import Draggable from 'react-draggable';
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import { PDFDocument } from "pdf-lib";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
    Invoices: 22,
};
function AgreementDetail({ AgreementID, onSuccess, ClientCompanyID, isLock, onClose }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [isClosed, SetIsClosed] = useState("0");

    const [formData, setFormData] = useState({
        ContractID: "0",
        CustomerID: 0,
        CustomerName: '',
        FK_ClientBranch_ID: 0,
        FK_ClientContact_ID: 0,
        AccountRef: '',
        dec_DiscountAmount: "0.00",
        mon_TotalPrice: "0.00",
        GrandTotal: "0.00",
        dec_DiscountNETTotal: "0.00",
        contractStartDate: new Date().toISOString().split('T')[0],
        contractEndDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        int_DiscountType: 0,
        IsPercentage: false,
        HostCompanyAddress: "",
        ContractFrequency: "",
        ClientType: "0",
        ClientCompanyName: "",
        Forename: "",
        Address1: "",
        Surname: ""


    });
    const [CustomerList, setCustomer] = useState([]);
    const [CustomerContactList, setCustomerContact] = useState([]);
    const [CustomerSiteList, setCustomerSite] = useState([]);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [ContractFrequecnyList, setContractFrequecny] = useState([]);
    const { theme } = useContext(ThemeContext);
    const [partList, setPartData] = useState([]);
    const [selectedParts, setSelectedParts] = useState([]);
    const [showPartModal, setShowPartModal] = useState(false);
    const [DiscountsList, setDiscounts] = useState([]);
    const [AgreementDetailList, setAgreementDetail] = useState([]);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [vatTax, setVatTax] = useState('0.00');
    const [currencyList, setCurrencies] = useState([]);
    const [currencyCustomerSymbol1, setCurrencyCustomerSymbol1] = useState('');
    const [currencyCostValue1, setCostCurrencyValue1] = useState('');
    const [BaseCurrency, setBaseCurrency] = useState('');
    const [convRate, setConRate] = useState('0.00');
    const [AutoRef, setAutoRef] = useState('');
    const [customerTax, setCustomerTax] = useState("0.00");
    const [customertaxType, setCustomertaxType] = useState("0");
    const [customerCategorytaxType, setCustomerCategoryType] = useState("0");
    const [customerCategoryTax, setCustomerCategoryTax] = useState("0");
    const [quantityTax, setQuantityTax] = useState("0");

    const [quantityBreak, setQuantityBreak] = useState();
    const [customerStockList, setCustomerStockList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [assignedModules, setAssignedModules] = useState(new Set());

    const [showDescriptionModal, setShowDescriptionModal] = useState(false);
    const [descriptionText, setDescriptionText] = useState("");
    const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
    const [KeyNameList, setKeyNames] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [pdfAttachment, setPdfAttachment] = useState(null);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, AgreementID, "9");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };

    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };
    const tableRef = useRef();
    const fetchCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            setCurrencies(currencyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchDefaultCurrency = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            setBaseCurrency(listOfCurreny[0].Symbol);

        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchVatTax = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const vatTax = await VatTaxService.GetVatTaxLabel(redirectCallback);
            if (vatTax.length > 0) {
                setVatTax(vatTax[0].vatTax);
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    useEffect(() => {
        SetIsClosed("0");
        fetchCurrency();
        fetchDefaultCurrency();
        // fetchVatTax();
        fetchCustomers();
        fetchContractFrequency();
        fetchAssignedModules();
        //  fetchParts();
        fetchDiscount();
        if (AgreementID > 0) {
            fetchAgreementDetail();
            fetchKeyNames();
        }
        else {
            resetForm();
            setSelectedParts([]);

            if (ClientCompanyID > 0) {
                fetchCustomerData(ClientCompanyID);
            }
            fetchKeyNames();
        }


    }, [AgreementID]);
    useEffect(() => {
        const updatedParts = selectedParts.map(part => {
            const salesPrice = parseFloat(part.mon_SalesPrice || 0);
            const netSalesPrice = parseFloat(part.net_SalesPrice || 0);
            const netVATPrice = parseFloat(part.net_VATPrice || 0);
            const quantity = parseFloat(part.vc_UnitOfSale || 0);
            const dec_Discount = parseFloat(part.dec_Discount || 0);
            const discount = (salesPrice * quantity) * ((dec_Discount) / 100);
            const total = netSalesPrice; // Assuming total is just the net sales price
            const totalVAT = netVATPrice;
            return { ...part, discount, total, totalVAT };
        });
        const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_SalesPrice || 0), 0);
        let totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.total || 0), 0);
        let totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount || 0), 0);
        const totalVATPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.totalVAT || 0), 0);

        if (formData.int_DiscountType === "3" || formData.int_DiscountType === 3) {
            totalDiscountedAmount = Math.round(parseFloat(totalDiscountedAmount).toFixed(2)) + Math.round(parseFloat((totalNetSalesPrice * formData.dec_DiscountAmount) / 100).toFixed(2));
            totalNetSalesPrice = (totalNetSalesPrice) * ((100 - formData.dec_DiscountAmount) / 100);

        }
        else if (formData.int_DiscountType === "4" || formData.int_DiscountType === 4) {
            totalDiscountedAmount = Math.round(totalDiscountedAmount) + Math.round(formData.dec_DiscountAmount);
            totalNetSalesPrice = totalNetSalesPrice - formData.dec_DiscountAmount;

        }
        setFormData((prevFormData) => ({
            ...prevFormData,
            dec_DiscountNETTotal: totalDiscountedAmount.toFixed(2),
            mon_TotalPrice: totalNetSalesPrice.toFixed(2),
            mon_TotalPriceO: totalVATPrice.toFixed(2),
            mon_TotalPriceG: (parseFloat(totalNetSalesPrice) + parseFloat(totalVATPrice)).toFixed(2)

        }));
    }, [selectedParts, formData.int_DiscountType, formData.dec_DiscountAmount]);



    const fetchCustomers = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            setCustomer(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };


    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };

    const fetchDiscountCategory = async (CustomerID) => {
        try {
            const redirectCallback = () => navigate('/');
            let listOfDiscounts = await CustomerDiscountService.GetAllCustomerDiscount(redirectCallback, CustomerID);
            listOfDiscounts = listOfDiscounts.find(cust => cust.IsDefault === 1);
            return listOfDiscounts;
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchCustomerCategoryDiscount = async (CustomerID) => {
        try {
            const redirectCallback = () => navigate('/');
            let listOfDiscounts = await CustomerCategoryDiscountService.GetCustomerCategoryDiscount(redirectCallback, CustomerID);
            listOfDiscounts = listOfDiscounts.find(cust => cust.IsDefault === 1);
            return listOfDiscounts;
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchCustomerStock = async (CustomerID) => {
        try {
            const redirectCallback = () => navigate('/');
            const stockList = await CustomerStockService.GetAllCustomerStock(redirectCallback, CustomerID);
            return stockList;

        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    const fetchContractFrequency = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfContractFrequencies = await ContractFrequency.GetAllContractFrequency(redirectCallback);
            setContractFrequecny(listOfContractFrequencies);
        } catch (error) {
            console.error('Error fetching contract frequencies:', error);
        }
    };

    const fetchCustomerContact = async (BranchID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setCustomerContact([]);
            const listOfCustomerContacts = await CustomerContactService.GetContactByBranch(redirectCallback, BranchID);
            setCustomerContact(listOfCustomerContacts);
            if (listOfCustomerContacts.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientContact_ID: listOfCustomerContacts[0].ClientContactID,
                }));
            }
        } catch (error) {
            console.error('Error fetching customer contacts:', error);
        }
    };
    const handleBranchChange = async (event) => {
        const { value } = event.target;
        const branchID = event.target.value;
        setFormData({
            ...formData,
            FK_ClientBranch_ID: value,
            FK_ClientContact_ID: 0
        });
        await fetchCustomerContact(value);

    };
    const fetchCustomersSites = async (customerID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const listOfCustomerSites = await CustomerSiteService.GetAllCustomersSites(redirectCallback, customerID);
            setCustomerSite(listOfCustomerSites);
            const headOfficeSite = listOfCustomerSites.find(site => site.HeadOffice === 1);
            if (headOfficeSite) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite.ClientBranchID,
                }));
                await fetchCustomerContact(headOfficeSite.ClientBranchID);
            } else if (listOfCustomerSites.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite.ClientBranchID,
                }));
                await fetchCustomerContact(listOfCustomerSites[0].ClientBranchID);
            }
        } catch (error) {
            console.error('Error fetching customer sites:', error);
        }
    };
    const populateCustomerSiteContactAccount = async (quotation) => {


        const redirectCallback = () => navigate('/');
        const customerId = quotation.ClientCompanyID;
        const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
        const selectedCustomer = listOfCustomers.find(customer => customer.ClientCompanyID === parseInt(customerId));

        const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
        const newCurrencySymbol = (selectedCustomer.vc_CurrencySymbol != null && selectedCustomer.vc_CurrencySymbol !== "" && selectedCustomer.vc_CurrencySymbol !== "undefined")
            ? selectedCustomer.vc_CurrencySymbol
            : listOfCurreny[0].Symbol;

        setVatTax(selectedCustomer.dec_Rate);
        //  fetchParts(selectedCustomer.ClientCompanyID);
        setCustomerTax(selectedCustomer.dec_Amount ?? 0.00);
        setCustomertaxType(selectedCustomer.FK_DiscountType_ID ?? 0);
        //Level 2 Discounting

        const CustomerStock = await fetchCustomerStock(selectedCustomer.ClientCompanyID);
        setCustomerStockList(CustomerStock);
        const CustomerCategoryDiscount = await fetchDiscountCategory(selectedCustomer.ClientCompanyID);
        if (CustomerCategoryDiscount) {
            setCustomerCategoryType(CustomerCategoryDiscount.PK_DiscountType_ID);
            setCustomerCategoryTax(CustomerCategoryDiscount.dec_Amount);
        }
        else {
            setCustomerCategoryType("0");
            setCustomerCategoryTax("0");
        }
        // END Level 2 Discounting
        //Level 3 Discounting
        let QuantityBreakDiscount = await fetchCustomerCategoryDiscount(selectedCustomer.ClientCompanyID);
        setQuantityBreak(QuantityBreakDiscount);
        //End Level 3 Discounting
        let ConvRate = "1.00";
        if (selectedCustomer.vc_CurrencySymbol != null && selectedCustomer.vc_CurrencySymbol != "" && selectedCustomer.vc_CurrencySymbol != "undefined") {
            setCurrencyCustomerSymbol1(selectedCustomer.vc_CurrencySymbol);
            ConvRate = await convertCurrency(BaseCurrency, selectedCustomer.vc_CurrencySymbol, currencyList, "0");
            setConRate(ConvRate);
        }
        else {
            setCurrencyCustomerSymbol1(listOfCurreny[0].Symbol);
            ConvRate = await convertCurrency(listOfCurreny[0].Symbol, listOfCurreny[0].Symbol, currencyList, "0");
            setConRate(ConvRate);
        }
        await fetchAgreementDescription(newCurrencySymbol, ConvRate);

        await fetchCustomersSites(customerId);
        await fetchCustomerContact(quotation.FK_ClientBranch_ID);

        setFormData(prev => ({
            ...prev,
            ...quotation,
            CustomerID: customerId,
            CustomerName: quotation.CompanyName,
            AccountRef: quotation.AccountRef,
            FK_ClientBranch_ID: quotation.FK_ClientBranch_ID,
            FK_ClientContact_ID: quotation.FK_ClientContact_ID,
            contractStartDate: new Date(quotation.contractStartDate).toISOString().split('T')[0],
            contractEndDate: new Date(quotation.contractEndDate).toISOString().split('T')[0],
            mon_TotalPriceG: quotation.mon_TotalPriceG,
        }));

    };

    const fetchParts = async (ClientCompanyID = 0) => {
        try {
            const redirectCallback = () => navigate('/');
            const data = await QuotationService.GetAllParts(redirectCallback, ClientCompanyID);
            setPartData(data);
        } catch (error) {
            console.error('Error fetching parts:', error);
        }
    };
    const fetchAgreementDescription = async (newCurrencySymbol, ConversionRate) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            if (AgreementID > 0) {
                const agreementDetails = await AgreementService.GetAgreementDescriptionByID(redirectCallback, AgreementID);

                const selectedPartsData = await Promise.all(agreementDetails.map(async (detail) => {
                    const convertedStockPrice = (detail.mon_StockPrice * ConversionRate)
                    const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                    const converteddec_Quantity = (detail.dec_Quantity * ConversionRate);
                    const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                    const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                    const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);

                    return {
                        vc_StockCode: detail.vc_StockCode,
                        vc_Description: detail.vc_Description,
                        mon_StockPrice: parseFloat(convertedStockPrice).toFixed(2), // Use the converted price
                        mon_SalesPrice: parseFloat(convertedmon_SalesPrice).toFixed(2),
                        dec_Quantity: detail.dec_Quantity,
                        vc_UnitOfSale: detail.vc_UnitOfSale,
                        net_SalesPrice: parseFloat(convertednet_SalesPrice).toFixed(2),
                        net_VATPrice: parseFloat(converteddetailnet_VATPrice).toFixed(2),
                        vc_StockName: detail.vc_Description,
                        PK_Stock_ID: detail.FK_Stock_ID,
                        dec_Discount: detail.dec_Discount,
                        mon_SellingPrice: parseFloat(convertedmon_SellingPrice).toFixed(2),
                        // Map other fields as needed
                    };
                }));
                setSelectedParts(selectedPartsData);
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    const fetchAgreementDetail = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            if (AgreementID > 0) {

                const agreementDetail = await AgreementService.GetAgreementByID(redirectCallback, AgreementID);
                const formattedDetail = {
                    ...agreementDetail[0],
                    contractStartDate: new Date(agreementDetail[0].contractStartDate).toISOString().split('T')[0],
                    contractEndDate: new Date(agreementDetail[0].contractEndDate).toISOString().split('T')[0],
                    mon_TotalPriceG: agreementDetail[0].mon_TotalPriceG,
                    CustomerID: agreementDetail[0].ClientCompanyID,
                    HostCompanyAddress: agreementDetail[0].HostCompanyAddress,

                };



                setFormData(prev => ({
                    ...prev,
                    formattedDetail
                }));

                if (agreementDetail[0].FK_Issue_ID > 0 || agreementDetail[0].FK_SalesOrder_ID > 0) {
                    SetIsClosed("1");
                }
                // Fetch and populate customer data
                populateCustomerSiteContactAccount(agreementDetail[0]);
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };

    const fetchCustomerData = async (customerID) => {
        try {
            const redirectCallback = () => navigate('/');
            const customerData = await CustomerService.GetCustomerByID(redirectCallback, customerID);

            if (customerData.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    CustomerName: customerData[0].CompanyName,
                    AccountRef: customerData[0].AccountRef,
                    HostCompanyAddress: customerData[0].HostCompanyAddress,
                }));
            }

            if (ClientCompanyID > 0) {
                await handleCustomerSelect(customerData[0]);
            }

            let ConvRate = "1.00";
            if (customerData[0].vc_CurrencySymbol != null && customerData[0].vc_CurrencySymbol != "" && customerData[0].vc_CurrencySymbol != "undefined") {
                setCurrencyCustomerSymbol1(customerData[0].vc_CurrencySymbol);
                ConvRate = await convertCurrency(BaseCurrency, customerData[0].vc_CurrencySymbol, currencyList, "0");
            }
            else {
                const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
                setCurrencyCustomerSymbol1(listOfCurreny[0].Symbol);
                ConvRate = "1.00"
            }
            await fetchCustomerContact(customerID);
            await fetchCustomersSites(customerID);
            await fetchAgreementDescription(customerData[0].vc_CurrencySymbol, ConvRate);
        } catch (error) {
            console.error('Error fetching customer data:', error);
        }
    };


    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setIsChanged(true);
        // Allow input of decimal points
        const isDecimalInput = name === "dec_DiscountAmount" && /^-?\d*\.?\d*$/.test(value);
        if (!isDecimalInput && name === "dec_DiscountAmount") return;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));

        if (name === "int_DiscountType" || name === "dec_DiscountAmount") {
            const discountValue = name === "int_DiscountType" ? value : formData.int_DiscountType;
            let amountValue = name === "dec_DiscountAmount" ? value : formData.dec_DiscountAmount;

            if (discountValue === "0") {
                amountValue = "0";
            }

            setFormData((prevFormData) => ({
                ...prevFormData,
                int_DiscountType: discountValue,
                dec_DiscountAmount: amountValue,

            }));
        }
    };

    // Calculation function
    const calculateQuantityBreakDiscount = (quantity, dec_Quantity) => {
        const QuantityDiscount = quantity;
        if (QuantityDiscount) {
            if (parseInt(dec_Quantity) >= parseInt(QuantityDiscount.dec_Quantity3)) {
                return QuantityDiscount.dec_Discount3;
            }
            else if (parseInt(dec_Quantity) >= parseInt(QuantityDiscount.dec_Quantity2) && parseInt(dec_Quantity) < parseInt(QuantityDiscount.dec_Quantity3)) {
                return QuantityDiscount.dec_Discount2;
            }
            else if (parseInt(dec_Quantity) >= parseInt(QuantityDiscount.dec_Quantity1) && parseInt(dec_Quantity) < parseInt(QuantityDiscount.dec_Quantity2)) {
                return QuantityDiscount.dec_Discount1;
            }
            else {
                return "0";
            }
        }
        else {
            return "0";
        }
    }

    // Calculation function
    const calculateNetSalesPrice = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {
        //Customer Discount 

        let TotalAmount = (salesPrice * dec_Quantity);
        /* if (customertaxType === "3" || customertaxType === 3) {
             TotalAmount = (TotalAmount) * ((100 - customerTax) / 100);
         }
         if (customertaxType === "4" || customertaxType === 4) {
             TotalAmount = TotalAmount - customerTax;
         }
         // END Customer Discount
         const StockDetail = customerStockList.filter(x => x.PK_Stock_ID === StockID);
         if (StockDetail.length > 0) {
             //Customer Discount Category 1
             if (customerCategorytaxType === "3" || customerCategorytaxType === 3) {
                 TotalAmount = (TotalAmount) * ((100 - customerCategoryTax) / 100);
             }
             if (customerCategorytaxType === "4" || customerCategorytaxType === 4) {
                 TotalAmount = TotalAmount - customerCategoryTax;
             }
             //END Customer Discount Category 1
             //Level 3 Discount
             const QuanitityDiscount = calculateQuantityBreakDiscount(quantityBreak, dec_Quantity);
             if (quantityBreak) {
                 TotalAmount = (TotalAmount) * ((100 - QuanitityDiscount) / 100);
             }
         }*/
        //End Level 3 Discount


        return parseFloat(TotalAmount).toFixed(2);
    };
    const calculateDiscountAmount = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {
        debugger;
        //Customer Discount 
        let TotalAmount = (salesPrice * dec_Quantity);
        let cusDiscountAmount = 0;
        /*   if (customertaxType === "3" || customertaxType === 3) {
               cusDiscountAmount = (TotalAmount) * (customerTax / 100);
               TotalAmount = (TotalAmount) * ((100 - customerTax) / 100);
           }
           if (customertaxType === "4" || customertaxType === 4) {
               cusDiscountAmount = customerTax;
               TotalAmount = TotalAmount - customerTax;
           }
           //End Customer Discount 
           //Customer Discount Category 1
           const StockDetail = customerStockList.filter(x => x.PK_Stock_ID === StockID);
           if (StockDetail.length > 0) {
               if (customerCategorytaxType === "3" || customerCategorytaxType === 3) {
                   cusDiscountAmount = cusDiscountAmount + (TotalAmount) * (customerCategoryTax / 100);
                   TotalAmount = (TotalAmount) * ((100 - customerCategoryTax) / 100);
               }
               if (customerCategorytaxType === "4" || customerCategorytaxType === 4) {
                   cusDiscountAmount = Math.round(parseFloat(cusDiscountAmount).toFixed(2)) + Math.round(parseFloat(customerCategoryTax).toFixed(2));
                   TotalAmount = TotalAmount - customerCategoryTax;
               }
               //END Customer Discount Category 1
               //Level 3 Discount
               const QuanitityDiscount = calculateQuantityBreakDiscount(quantityBreak, dec_Quantity);
               if (quantityBreak) {
                   cusDiscountAmount = cusDiscountAmount + (TotalAmount) * (QuanitityDiscount / 100);
                   TotalAmount = (TotalAmount) * ((100 - QuanitityDiscount) / 100);
               }
           }*/
        //End Level 3 Discoutn


        return parseFloat(cusDiscountAmount).toFixed(2);
    };
    const calculateDiscountPrice = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {
        const vatTaxPercent = vatTax;

        //Customer Discount
        let TotalAmount = (salesPrice * dec_Quantity);
        /*    if (customertaxType === "3" || customertaxType === 3) {
              TotalAmount = (TotalAmount) * ((100 - customerTax) / 100);
          }
          if (customertaxType === "4" || customertaxType === 4) {
              TotalAmount = TotalAmount - customerTax;
  
          }
          // END Customer Discount
          //Customer Discount Category 1
          const StockDetail = customerStockList.filter(x => x.PK_Stock_ID === StockID);
          if (StockDetail.length > 0) {
              if (customerCategorytaxType === "3" || customerCategorytaxType === 3) {
                  TotalAmount = (TotalAmount) * ((100 - customerCategoryTax) / 100);
              }
              if (customerCategorytaxType === "4" || customerCategorytaxType === 4) {
                  TotalAmount = TotalAmount - customerCategoryTax;
  
              }
              //End Customer Discount Category 1
              //Level 3 Discount
              const QuanitityDiscount = calculateQuantityBreakDiscount(quantityBreak, dec_Quantity);
              if (quantityBreak) {
                  TotalAmount = (TotalAmount) * ((100 - QuanitityDiscount) / 100);
              }
          }*/
        // End Level 3 Discount


        let newPrice = (TotalAmount * vatTaxPercent) / 100;
        return (newPrice).toFixed(2);
    };

    const handleSalesPriceChange = (index, newSalesPrice, fieldName) => {
        if (fieldName === "mon_SalesPrice") {
            const updatedParts = selectedParts.map((part, i) => {
                if (i === index) {
                    const netPrice = calculateNetSalesPrice(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    const VATPrice = calculateDiscountPrice(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    const dec_Discount = calculateDiscountAmount(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    return {
                        ...part,
                        mon_SalesPrice: newSalesPrice.value,
                        net_SalesPrice: netPrice,
                        net_VATPrice: VATPrice,
                        dec_Discount: dec_Discount
                    };
                }
                return part;
            });
            setSelectedParts(updatedParts);
        }
        else if (fieldName === "dec_Quantity") {

            const updatedParts = selectedParts.map((part, i) => {
                if (i === index) {


                    const netPrice = calculateNetSalesPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice.value, part.dec_Discount, part.PK_Stock_ID);
                    const VATPrice = calculateDiscountPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice.value, part.dec_Discount, part.PK_Stock_ID);
                    const dec_Discount = calculateDiscountAmount(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    return {
                        ...part,
                        dec_Quantity: newSalesPrice.value,
                        net_SalesPrice: netPrice,
                        net_VATPrice: VATPrice,
                        dec_Discount: dec_Discount
                    };
                }
                return part;
            });

            // Calculate the sum of mon_SalesPrice and net_SalesPrice
            let totalDiscountedAmount = 0;
            if (formData.int_DiscountType === "3") {
                const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_StockPrice), 0);
                const totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.net_SalesPrice), 0);
                totalDiscountedAmount = totalSalesPrice - totalNetSalesPrice;
            }
            else if (formData.int_DiscountType === "4") {

                totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount), 0);
            }
            // Update the state with the new parts and the total discounted amount
            setSelectedParts(updatedParts);

        }
    };


    const handleQuantityChange = (index, newSalesPrice) => {
        const updatedParts = selectedParts.map((part, i) => {
            if (i === index) {
                const netPrice = calculateNetSalesPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                const VATPrice = calculateDiscountPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                const dec_Discount = calculateDiscountAmount(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                return {
                    ...part,
                    vc_UnitOfSale: newSalesPrice,
                    net_SalesPrice: netPrice,
                    net_VATPrice: VATPrice,
                    dec_Discount: dec_Discount
                };
            }
            return part;
        });

        // Calculate the sum of mon_SalesPrice and net_SalesPrice
        let totalDiscountedAmount = 0;
        if (formData.int_DiscountType === "3") {
            const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_SalesPrice), 0);
            const totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.net_SalesPrice), 0);
            const totalDiscountedAmount = totalSalesPrice - totalNetSalesPrice;
        }
        else if (formData.int_DiscountType === "4") {
            totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount), 0);
        }
        // Update the state with the new parts and the total discounted amount
        setSelectedParts(updatedParts);

    };



    const handlePartChange = (event, index, fieldName) => {
        const { value } = event.target;
        const updatedParts = [...selectedParts];
        const part = updatedParts[index];
        part[fieldName] = value;

        if (fieldName === "mon_SalesPrice") {

            part.net_SalesPrice = calculateNetSalesPrice(part.mon_SalesPrice, formData.dec_DiscountAmount, formData.IsPercentage, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
        }

        setSelectedParts(updatedParts);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        if (AgreementID > 0 && !isChanged) {
            return;
        }
        try {
            const redirectUserList = () => {
                navigate('/AgreementList?saved=true');
            };
            const redirectCallback = () => navigate('/');
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            const targetCurrency = currencyCustomerSymbol1 || BaseCurrency;
            const ConversionRate = await convertCurrency(listOfCurreny[0].Symbol, targetCurrency, currencyList, "0");
            const selectedPartsData = await Promise.all(selectedParts.map(async (detail) => {
                const convertedStockPrice = (detail.mon_StockPrice / ConversionRate);
                const convertedmon_SalesPrice = (detail.mon_SalesPrice / ConversionRate);
                const convertednet_SalesPrice = (detail.net_SalesPrice / ConversionRate);
                const converteddetailnet_VATPrice = (detail.net_VATPrice / ConversionRate);
                const convertedmon_SellingPrice = (detail.mon_SellingPrice / ConversionRate);
                return {
                    vc_StockCode: detail.vc_StockCode,
                    vc_Description: detail.vc_Description,
                    mon_StockPrice: convertedStockPrice, // Use the converted price
                    mon_SalesPrice: convertedmon_SalesPrice,
                    dec_Quantity: detail.dec_Quantity,
                    vc_UnitOfSale: detail.vc_UnitOfSale,
                    net_SalesPrice: convertednet_SalesPrice,
                    net_VATPrice: converteddetailnet_VATPrice,
                    vc_StockName: detail.vc_Description,
                    PK_Stock_ID: detail.FK_Stock_ID,
                    dec_Discount: detail.dec_Discount,
                    mon_SellingPrice: convertedmon_SellingPrice,
                    vc_CommodityCode: detail.vc_CommodityCode,
                    dec_TaxCode: detail.dec_TaxCode,
                    dec_UnitWeight: detail.dec_UnitWeight,
                    snt_PurchaseNominalCode: detail.snt_PurchaseNominalCode,
                    dec_VAT: detail.dec_VAT,
                    mon_VATPriceForeignCurrency: detail.mon_VATPriceForeignCurrency,
                    PK_Stock_ID: detail.PK_Stock_ID,
                };
            }));
            const formDataWithParts = {
                formData: formData,
                selectedParts: selectedPartsData
            };

            const message = await handleSubmit(event, formDataWithParts, setFormData, setErrors);
            if (message == "Data saved successfully") {
                setIsChanged(false);
                onSuccess();
                AgreementID = localStorage.getItem('AgreementID');
                await handleUserDefineSubmit({
                    JobID: localStorage.getItem('AgreementID'),
                    fields: KeyNameList.map(key => ({
                        PK_KeyName_ID: key.PK_KeyName_ID,
                        value: formData[key.vc_Name] || ''
                    }))
                });
                fetchKeyNames();
                localStorage.setItem('HasRecordUpdated', "1");
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
                // redirectUserList();
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };

    const handleCustomerSelect = async (customer) => {
        debugger;
        setIsChanged(true);
        setFormData({
            ...formData,
            CustomerID: customer.ClientCompanyID,
            CustomerName: customer.CompanyName,
            AccountRef: customer.AccountRef,
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0
        });

        const newCurrencySymbol = (customer.vc_CurrencySymbol != null && customer.vc_CurrencySymbol !== "" && customer.vc_CurrencySymbol !== "undefined")
            ? customer.vc_CurrencySymbol
            : BaseCurrency;

        const CustomerStock = await fetchCustomerStock(customer.ClientCompanyID);
        setCustomerStockList(CustomerStock);
        const CustomerCategoryDiscount = await fetchDiscountCategory(customer.ClientCompanyID);
        if (CustomerCategoryDiscount) {
            setCustomerCategoryType(CustomerCategoryDiscount.PK_DiscountType_ID);
            setCustomerCategoryTax(CustomerCategoryDiscount.dec_Amount);
        }
        else {
            setCustomerCategoryType("0");
            setCustomerCategoryTax("0");
        }

        //Level 3 Discount
        let QuantityBreakDiscount = await fetchCustomerCategoryDiscount(customer.ClientCompanyID);
        setQuantityBreak(QuantityBreakDiscount);
        setVatTax(customer.dec_Rate);
        setCustomerTax(customer.dec_Amount ?? 0.00);
        setCustomertaxType(customer.FK_DiscountType_ID ?? 0);
        //   fetchParts(customer.ClientCompanyID);
        const ConversionRate = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
        setCurrencyCustomerSymbol1(newCurrencySymbol);
        setConRate(ConversionRate);
        if (AgreementID > 0) {
            await fetchAgreementDescription(newCurrencySymbol, ConversionRate);
        }
        else {

            const selectedPartsData = await Promise.all(selectedParts.map(async (detail) => {
                const convertedStockPrice = (detail.mon_StockPrice * ConversionRate);
                const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);
                return {
                    vc_StockCode: detail.vc_StockCode,
                    vc_Description: detail.vc_Description,
                    mon_StockPrice: parseFloat(convertedStockPrice).toFixed(2), // Use the converted price
                    mon_SalesPrice: parseFloat(convertedmon_SalesPrice).toFixed(2),
                    dec_Quantity: detail.dec_Quantity,
                    net_SalesPrice: parseFloat(convertednet_SalesPrice).toFixed(2),
                    net_VATPrice: parseFloat(converteddetailnet_VATPrice).toFixed(2),
                    vc_StockName: detail.vc_Description,
                    PK_Stock_ID: detail.FK_Stock_ID,
                    dec_Discount: detail.dec_Discount,
                    mon_SellingPrice: parseFloat(convertedmon_SellingPrice).toFixed(2),
                    // Map other fields as needed
                };
            }));
            setSelectedParts(selectedPartsData);
        }


        fetchCustomerContact(customer.ClientCompanyID);
        fetchCustomersSites(customer.ClientCompanyID);
        setShowCustomerModal(false);
    };

    const handlePartSelect = async (selectedPartsArray) => {
        setIsChanged(true);
        const targetCurrency = currencyCustomerSymbol1 || BaseCurrency;
        const ConversionRate = await convertCurrency(BaseCurrency, targetCurrency, currencyList, "0");
        const convertedParts = selectedPartsArray.map(part => {
            const convertedStockPrice = (part.mon_StockPrice * ConversionRate);
            const convertedmon_SalesPrice = (part.mon_SalesPrice * ConversionRate);
            const convertednet_SalesPrice = (part.net_SalesPrice * ConversionRate);
            const converteddetailnet_VATPrice = (part.net_VATPrice * ConversionRate);
            const convertedmon_SellingPrice = (part.mon_SellingPrice * ConversionRate);


            return {
                ...part,
                mon_StockPrice: convertedStockPrice,
                mon_SalesPrice: convertedmon_SalesPrice,
                mon_SellingPrice: convertedmon_SalesPrice,
                dec_Discount: calculateDiscountAmount(convertedmon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, formData.dec_DiscountAmount, part.PK_Stock_ID),
                net_SalesPrice: calculateNetSalesPrice(convertedmon_SalesPrice, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, formData.dec_DiscountAmount, part.PK_Stock_ID),
                net_VATPrice: calculateDiscountPrice(parseFloat(convertedmon_SalesPrice || 0), formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, formData.dec_DiscountAmount, part.PK_Stock_ID),



            };
        });
        setSelectedParts(prev => [...prev, ...convertedParts]);
        setShowPartModal(false);

    };
    const handleCustomerClick = (e) => {
        e.preventDefault();
        setShowCustomerModal(true);
    };
    const handleAutoRef = async (e) => {

        e.preventDefault();
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        if (!formData.CustomerName) {
            Swal.fire(
                '',
                'Please select a customer to generate a reference.',
                'warning'
            );
        }
        else {
            let CompanyName = formData &&
                formData.CustomerName ? formData.CustomerName.substring(0, 2).toUpperCase() : '';
            const AgreementRef = await AgreementService.AgreementAutoRef(redirectCallback);
            if (AgreementRef.length > 0) {
                setFormData({
                    ...formData,
                    contractNumber: AgreementRef[0].ContractRef + CompanyName
                });
            }
        }

    };
    const handleRemovePart = (index) => {
        const updatedParts = selectedParts.filter((part, i) => i !== index);
        setSelectedParts(updatedParts);
    };
    const HelpLink = localStorage.getItem('HelpLink');
    const resetForm = () => {

        setFormData({
            ContractID: "0",
            CustomerID: 0,
            CustomerName: '',
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0,
            AccountRef: '',
            dec_DiscountAmount: "0.00",
            mon_TotalPrice: "0.00",
            GrandTotal: "0.00",
            dec_DiscountNETTotal: "0.00",
            contractStartDate: new Date().toISOString().split('T')[0],
            contractEndDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
            int_DiscountType: 0,
            IsPercentage: false,
            contractNumber: "",
            billing_Frequency: 0,
            ClientType: "0",
            ClientCompanyName: "",
            Forename: "",
            Address1: "",
            Surname: ""
        });
    };
    const handleAddRow = () => {
        const newRow = {
            PK_Stock_ID: 0,
            vc_StockCode: "S1",            // Default Product Code
            vc_Description: "Free Text",            // Default Description (Free text)
            mon_SalesPrice: "0.00",        // Default Sale Price
            vc_UnitOfSale: "0.00",
            dec_Discount: "0.00",
            net_SalesPrice: "0.00",
            net_VATPrice: "0.00",
            mon_StockPrice: "0.00",
            dec_Quantity: "0",
            isNew: true,  // This will help identify newly added rows
            ClientType: "0",
            ClientCompanyName: "",
            Forename: "",
            Address1: "",
            Surname: ""

        };
        setSelectedParts([...selectedParts, newRow]);
    };

    const AgreementDetail = async (AgreementID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (AgreementID > 0) {

                const agreementDetail = await AgreementService.GetAgreementByID(redirectCallback, AgreementID);
                return agreementDetail;
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    const { handleSaleOrder } = useSaleOrder(setLoading, setSelectedParts, tableRef, []);
    const handleCreateSaleOrder = async (event) => {
        if (AgreementID > 0) {
            debugger;
            const agreementDetail = await AgreementDetail(AgreementID);
            if (agreementDetail[0].FK_SalesOrder_ID > 0) {
                Swal.fire(
                    'Error!',
                    'Sale Order already exist for the selected agreement.',
                    'warning'
                );
            }
            else {
                debugger;
                const result = await Swal.fire({
                    title: 'Are you sure?',
                    text: "Create sale order from the selected agreement!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Create it!'
                });

                if (result.isConfirmed) {
                    const message = await handleSaleOrder(event, AgreementID);
                    if (message === "Data saved successfully") {
                        Swal.fire(
                            'Success!',
                            'Sale Order Created Successfully.',
                            'warning'
                        );
                        SetIsClosed("1");
                        fetchAgreementDetail();

                    }
                }
            }
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to create a sale Order.',
                'warning'
            );
        }

    };
    const { handleInvoice } = useInvoice(setLoading, setSelectedParts, tableRef, []);
    const handleCreateInvoice = async (event) => {
        if (AgreementID > 0) {
            debugger;
            const agreementDetail = await AgreementDetail(AgreementID);
            if (agreementDetail[0].FK_Invoice_ID > 0) {
                Swal.fire(
                    'Error!',
                    'Invoice already exist for the selected agreement.',
                    'warning'
                );
            }
            else {
                debugger;
                const result = await Swal.fire({
                    title: 'Are you sure?',
                    text: "Create invoice from the selected agreement!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Create it!'
                });

                if (result.isConfirmed) {
                    const message = await handleInvoice(event, AgreementID);
                    if (message === "Data saved successfully") {
                        Swal.fire(
                            'Success!',
                            'Invoice Created Successfully.',
                            'warning'
                        );
                        localStorage.setItem('HasRecordUpdated', "1");
                        SetIsClosed("1");
                        fetchAgreementDetail();

                    }
                }
            }
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to create an invoice.',
                'warning'
            );
        }

    };
    const handleRenewAgreement = async (event) => {

        if (AgreementID > 0) {
            debugger;
            const agreementDetail = await AgreementDetail(AgreementID);
            if (agreementDetail[0].FK_SalesOrder_ID > 0) {
                Swal.fire(
                    'Error!',
                    'You can not renew the selected agreement as the Sale order has been created for the selected agreement.',
                    'warning'
                );
            }
            else {
                const today = new Date();
                const endDate = new Date(agreementDetail[0].contractEndDate);

                // Calculate the difference in time (in milliseconds)
                const timeDiff = endDate - today;

                // Convert time difference to days
                const dayDiff = timeDiff / (1000 * 60 * 60 * 24);

                let status = "";
                if (dayDiff < 0) {
                    status = "Expired";
                } else if (dayDiff <= 30) {
                    status = "Expiry";
                }
                if (status === "") {
                    Swal.fire(
                        'Error!',
                        'Only Expired and Expiry soon agerement can be renewed.',
                        'warning'
                    );
                }
                else {
                    debugger;
                    const result = await Swal.fire({
                        title: 'Are you sure?',
                        text: "you wish to Renew the Selected Agreement!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, Create it!'
                    });

                    if (result.isConfirmed) {
                        debugger;
                        const message = await AgreementService.RenewAgreement(AgreementID);
                        if (message === "Data saved successfully") {
                            Swal.fire(
                                'Success!',
                                'Selected Agreement renewed Successfully.',
                                'warning'
                            );
                            //  await fetchAgreement();

                        }
                    }

                }
            }
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to create a sale Order.',
                'warning'
            );
        }

    };
    const [imageData, setImageData] = useState(null);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [error, setError] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false);
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }
                debugger;
                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);

    const generatePDF = async (event) => {
        event.stopPropagation();

        try {
            const result = await Swal.fire({
                title: "Include Terms & Conditions?",
                text: "Do you want to include Terms & Conditions in the print?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes, include it",
                cancelButtonText: "No, just main report",
            });

            const includeTerms = result.isConfirmed;

            const blob = await getMergedPDFBlob(includeTerms);

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);

            localStorage.setItem('HasRecordUpdated', "1");

        } catch (err) {
            console.error(err);
        }
    };

    const generatePDFForEmail = async () => {
        try {
            setLoading(true);

            const blob = await getMergedPDFBlob();

            const file = new File([blob], 'Invoice.pdf', {
                type: 'application/pdf'
            });

            setPdfAttachment(file); // ✅ SAME FILE
            setIsEmailModalOpen(true);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const getMergedPDFBlob = async (includeTerms = true) => {

        try {

            const currentInputValues = {
                ClientID: localStorage.getItem("CompanyID"),
                ID: AgreementID
            };

            const redirectCallback = () => {
                navigate('/');
            };

            // ================= MAIN REPORT =================

            let reportData = await ReportService.GetCompanyReports(
                redirectCallback,
                "9"
            );

            reportData = reportData.filter(
                x => x.IsDefault.toString() === "1"
            );

            const reportID =
                reportData.length > 0
                    ? reportData[0].ID
                    : 123;

            const JasperReport =
                await JasperReportService.GetJasperReportByID(reportID);

            let url = JasperReport[0].Link;

            setReportLink(url);

            setReportTitle(JasperReport[0].ReportTitle);

            // replace placeholders in main report
            Object.keys(currentInputValues).forEach((key) => {

                const placeholder = new RegExp(`{${key}}`, 'g');

                let value = currentInputValues[key];

                if (key === "ClientID") {

                    value = localStorage.getItem("CompanyID");

                } else if (key === "UserID") {

                    value = localStorage.getItem("UserID");

                }

                if (url.includes(`{${key}}`)) {

                    url = url.replace(placeholder, value);

                }

            });

            const queryObjMain = {
                ...currentInputValues,
                format: 'pdf',
                ReportName: JasperReport[0].ReportName,
                ReportType: JasperReport[0].ReportType,
                name: JasperReport[0].ReportName
            };

            const queryStringMain =
                new URLSearchParams(queryObjMain).toString();

            const responseMain = await axiosInstance.get(
                `/Dashboard/ProxyReport?${queryStringMain}`,
                { responseType: 'blob' }
            );

            const mainPdfBytes =
                await responseMain.data.arrayBuffer();

            // ================= MERGE PDFs =================

            const mergedPdf = await PDFDocument.create();

            const mainPdf =
                await PDFDocument.load(mainPdfBytes);

            const mainPages =
                await mergedPdf.copyPages(
                    mainPdf,
                    mainPdf.getPageIndices()
                );

            mainPages.forEach((page) =>
                mergedPdf.addPage(page)
            );

            // ================= TERMS PDF =================

            if (includeTerms) {

                const companySetup =
                    await CompanySetupController.GetCompanyByID(
                        redirectCallback,
                        localStorage.getItem("CompanyID")
                    );

                const termFile =
                    companySetup?.[0]?.TermFile;

                // Only attach second PDF if file exists
                if (termFile) {

                    const ClientID =
                        localStorage.getItem('CompanyID');

                    const FileUrl =
                        `${BASE_URL}/uploads/${ClientID}/Admin/TermConditions/${termFile}`;

                    const responseSecond =
                        await axiosInstance.get(
                            FileUrl,
                            { responseType: 'blob' }
                        );

                    const secondPdfBytes =
                        await responseSecond.data.arrayBuffer();

                    const secondPdf =
                        await PDFDocument.load(secondPdfBytes);

                    const secondPages =
                        await mergedPdf.copyPages(
                            secondPdf,
                            secondPdf.getPageIndices()
                        );

                    secondPages.forEach((page) =>
                        mergedPdf.addPage(page)
                    );
                }
            }

            const mergedPdfBytes =
                await mergedPdf.save();

            return new Blob(
                [mergedPdfBytes],
                { type: "application/pdf" }
            );

        } catch (err) {

            console.error("Error executing report:", err);

            setError("Failed to execute the report.");

            return null;
        }
    };


    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const truncateTextPdf = (text, maxLength = 25) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };
    const handleRadioChange = (event) => {
        const { value } = event.target;

        // Create a base object with `type` updated
        let updatedFormData = {
            ...formData,
            ClientType: value
        };

        // Extend `updatedFormData` with additional fields based on the selected value
        if (value === "1") {
            // setCustomerModal(true);
        } else if (value === "2") {
            // setLeadModal(true);
        } else if (value === "2") {
            // setOpportunityModal(true);
        }

        // Update the formData state with the final object
        setFormData(updatedFormData);
    };
    const handleAddNewItem = (event) => {
        if (formData.CustomerID > 0) {
            setShowPartModal(true);
        }
        else {
            Swal.fire(
                'Warning!',
                'Please select company first.',
                'warning'
            );
        }
    }
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="row mb-3">
                <div className="col-xl-12" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <form onSubmit={handleFormSubmit} style={{
                // IE/Edge
            }}>
                <div

                >
                    <table style={{ width: "100%" }}>
                        <tbody>

                            {formData.ClientType?.toString() === "0" && (
                                <>
                                    <tr>
                                        <td style={{ width: "13%" }}><label htmlFor="CustomerID" style={{ float: "right" }}>Company :<span style={{ "color": "red" }}>*</span></label></td>
                                        <input type="hidden" name="ContractID" value={formData.ContractID} onChange={handleFieldChange} />
                                        <td style={{ width: "37%" }}>

                                            <input
                                                type="text"
                                                className="form-control"
                                                id="CustomerID"
                                                name="CustomerID"
                                                value={formData.CustomerName}
                                                onClick={() => setShowCustomerModal(true)}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}
                                            />
                                            {errors.CustomerID && <div style={{ color: 'red' }}>{errors.CustomerID}</div>}
                                        </td>

                                        <td style={{ width: "14%" }}><label htmlFor="vc_SerialNumber" style={{ float: "right" }}>Site Name :<span style={{ "color": "red" }}>*</span></label></td>
                                        <td style={{ width: "36%" }}>
                                            <select name="FK_ClientBranch_ID" className='form-control' value={formData.FK_ClientBranch_ID} onChange={handleBranchChange} disabled={isClosed === '1' || isClosed === 1}>
                                                <option value="0">Select Site Name</option>
                                                {CustomerSiteList.map((site) => (
                                                    <option key={site.ClientBranchID} value={site.ClientBranchID}>
                                                        {site.BranchName}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.FK_ClientBranch_ID && <div style={{ color: 'red' }}>{errors.FK_ClientBranch_ID}</div>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label htmlFor="FK_ClientContact_ID" style={{ float: "right" }}>Contact:<span style={{ "color": "red" }}>*</span></label></td>
                                        <td>
                                            <select name="FK_ClientContact_ID" className='form-control' value={formData.FK_ClientContact_ID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                                <option value="0">Select Contact</option>
                                                {CustomerContactList.map((contact) => (
                                                    <option key={contact.ClientContactID} value={contact.ClientContactID}>
                                                        {contact.Title} {contact.FirstName} {contact.SurName}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.FK_ClientContact_ID && <div style={{ color: 'red' }}>{errors.FK_ClientContact_ID}</div>}
                                        </td>
                                        <td><label htmlFor="AccountRef" style={{ float: "right" }}>Account Ref</label></td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="AccountRef"
                                                name="AccountRef"
                                                value={formData.AccountRef}
                                                onChange={(e) => setFormData({ ...formData, AccountRef: e.target.value })}
                                                readOnly
                                                disabled={isClosed === '1' || isClosed === 1}
                                            />
                                        </td>
                                    </tr>
                                </>
                            )}
                            {formData.ClientType?.toString() === "1" && (
                                <>
                                    <tr>
                                        <td>
                                            <label htmlFor="ClientCompanyName" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="ClientCompanyName" value={formData.ClientCompanyName} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.ClientCompanyName && <div style={{ color: 'red' }}>{errors.ClientCompanyName}</div>}
                                        </td>
                                        <td>
                                            <label htmlFor="Forename" style={{ float: "right" }}>Forename <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="Forename" value={formData.Forename} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.Forename && <div style={{ color: 'red' }}>{errors.Forename}</div>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label htmlFor="Address1" style={{ float: "right" }}>Address <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="Address1" value={formData.Address1} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.Address1 && <div style={{ color: 'red' }}>{errors.Address1}</div>}
                                        </td>
                                        <td>
                                            <label htmlFor="dt_QuotationDate" style={{ float: "right" }}>Surname <span style={{ "color": "red" }}>*</span></label>
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" name="Surname" value={formData.Surname} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                            {errors.Surname && <div style={{ color: 'red' }}>{errors.Surname}</div>}
                                        </td>
                                    </tr>
                                </>

                            )}
                            <tr>
                                <td><label htmlFor="contractStartDate" style={{ float: "right" }}>Start Date:<span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="date" className="form-control" name="contractStartDate" value={formData.contractStartDate} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.contractStartDate && <div style={{ color: 'red' }}>{errors.contractStartDate}</div>}
                                </td>
                                <td><label htmlFor="contractEndDate" style={{ float: "right" }}>End Date:<span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="date" className="form-control" name="contractEndDate" value={formData.contractEndDate} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.contractEndDate && <div style={{ color: 'red' }}>{errors.contractEndDate}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="contractNumber" style={{ float: "right" }}>Reference:<span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input type="text" className="form-control" name="contractNumber" value={formData.contractNumber} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                        {errors.contractNumber && <div style={{ color: 'red' }}>{errors.contractNumber}</div>}
                                    </td>
                                        <td>
                                            <button type="button" className="btn btn-primary" onClick={handleAutoRef}>
                                                <img src="assets/img/resources/auto.png" alt="Add icon" style={{ height: "10px" }} />  Auto
                                            </button>
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                                <td><label htmlFor="contractEndDate" style={{ float: "right" }}>Billing Frequency:<span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <select
                                        name="billing_Frequency"
                                        className='form-control'
                                        value={formData.billing_Frequency}
                                        onChange={handleFieldChange}
                                        disabled={isClosed === '1' || isClosed === 1}
                                    >
                                        <option value="0">Select Billing Frequency</option>
                                        {ContractFrequecnyList.map((freq) => (
                                            <option key={freq.ID} value={freq.ID}>
                                                {freq.ContractFrequency}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.billing_Frequency && <div style={{ color: 'red' }}>{errors.billing_Frequency}</div>}
                                </td>
                            </tr>
                            {KeyNameList.length > 0 && (
                                <>
                                    <LeadUserDefineFieldsSection
                                        KeyNameList={KeyNameList}
                                        formData={formData}
                                        errors={errors}
                                        handleInputChange={handleFieldChange}
                                        handleDecimalChange={handleDecimalChange}
                                        handleIntegerChange={handleIntegerChange}
                                        handleFileChange={handleFileChange}
                                    />
                                </>
                            )}
                        </tbody>
                    </table>
                    <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                        <div className='col-sm-12' >
                            <table className="table datatable table-bordered">
                                <thead>
                                    <tr>
                                        <th className="no-wrap" style={{ "width": "13%" }}>Product Code</th>
                                        <th className="no-wrap" style={{ "width": "20%" }}>Description</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Cost Price</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Sales Price</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Quantity</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Discount</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Net</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>VAT</th>
                                        <th style={{ "width": "7%" }}>Actions</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div className='col-sm-12' style={{ "overflowY": "auto", "maxHeight": "150px", "marginTop": "-10px" }}>
                            <table className="table datatable table-bordered">
                                <tbody>
                                    {selectedParts.map((part, index) => (
                                        <tr key={index}>
                                            <td className="no-wrap" style={{ "width": "13%" }}>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={part.vc_StockCode}
                                                    readOnly="true"
                                                    onChange={(e) => handlePartChange(e, index, 'vc_StockCode')}
                                                    disabled={isClosed === '1' || isClosed === 1}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "20%" }}>
                                                <div
                                                    onMouseEnter={(e) => {
                                                        const rect = e.target.getBoundingClientRect();
                                                        setModalPosition({ top: rect.top + window.scrollY - 50, left: rect.left });
                                                        setDescriptionText(part.vc_Description);
                                                        setShowDescriptionModal(true);
                                                    }}
                                                    onMouseLeave={() => setShowDescriptionModal(false)}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={part.vc_Description}
                                                        onChange={(e) => {
                                                            const updatedPart = { ...part, vc_Description: e.target.value };
                                                            const updatedParts = [...selectedParts];
                                                            updatedParts[index] = updatedPart;
                                                            setSelectedParts(updatedParts);
                                                        }}
                                                        disabled={isClosed === '1' || isClosed === 1}
                                                    />
                                                </div>
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField initialCurrencySymbol={currencyCustomerSymbol1}
                                                    initialCurrencyValue={part.mon_StockPrice} currencyList={currencyList}
                                                    disabled={true} />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField initialCurrencySymbol={currencyCustomerSymbol1} initialCurrencyValue={part.mon_SalesPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => handleSalesPriceChange(index, newValue, 'mon_SalesPrice')} />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <input
                                                    type="hidden"
                                                    className="form-control"
                                                    value={part.dec_Discount}
                                                    readOnly="true"
                                                    onChange={(e) => {
                                                        const updatedPart = { ...part, dec_Discount: e.target.value };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);

                                                    }}
                                                    disabled={isClosed === '1' || isClosed === 1}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={part.vc_UnitOfSale}
                                                    onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                    disabled={isClosed === '1' || isClosed === 1}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>

                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1}
                                                    initialCurrencyValue={part.dec_Discount}
                                                    currencyList={currencyList}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1}
                                                    initialCurrencyValue={part.net_SalesPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, net_SalesPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencyCustomerSymbol1}
                                                    initialCurrencyValue={part.net_VATPrice}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, net_VATPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td style={{ "textAlign": "right", "width": "7%" }}>
                                                <button
                                                    type="button"
                                                    style={{ "background": "none", "border": "none" }}
                                                    className={`text-danger ${isLock > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}
                                                    onClick={() => handleRemovePart(index)}
                                                    disabled={isClosed === '1' || isClosed === 1 || isLock > 0}
                                                >
                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* Add more form fields as needed */}

                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Discount</label>
                        <div className="col-sm-4">
                            <select name="int_DiscountType" className='form-control' value={formData.int_DiscountType}
                                onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                <option value="0">Select Discount</option>
                                {DiscountsList.map((discount) => (
                                    <option key={discount.PK_DiscountType_ID} value={discount.PK_DiscountType_ID}>
                                        {discount.vc_Name}
                                    </option>
                                ))}
                            </select>
                        </div>

                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-2 col-form-label">Discount Amount</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" name="dec_DiscountAmount" value={formData.dec_DiscountAmount}
                                onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                        </div>
                        <label htmlFor="dec_DiscountNETTotal" className="col-sm-2 col-form-label">Discount</label>
                        <div className="col-sm-2">


                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1}
                                initialCurrencyValue={formData.dec_DiscountNETTotal}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">

                        </div>
                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-6 col-form-label"></label>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Orders Total</label>
                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1}
                                initialCurrencyValue={formData.mon_TotalPrice}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1}
                                initialCurrencyValue={formData.mon_TotalPriceO}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-6 col-form-label"></label>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Grand Total</label>
                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencyCustomerSymbol1}
                                initialCurrencyValue={formData.mon_TotalPriceG}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">
                            <CurrencyTextField
                                initialCurrencySymbol={BaseCurrency}
                                initialCurrencyValue={parseFloat((formData.mon_TotalPriceG) / (convRate)).toFixed(2)}
                                currencyList={currencyList}

                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                    <div className="col-sm-8">
                        {(assignedModules.has(MODULE_IDS.Parts) &&
                            <button style={{ background: "#00796B" }} type="button" className={`btn btn-primary ${isLock > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleAddNewItem} disabled={isClosed === '1' || isClosed === 1 || isLock > 0 || !assignedModules.has(MODULE_IDS.Parts)}>
                                <i className="icofont-plus" aria-hidden="true"> Add Item</i>
                            </button>
                        )}
                        <button style={{ "marginLeft": "5px", background: "#0288D1" }} type="button" className={`btn btn-secondary ${isLock > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleAddRow} disabled={isClosed === '1' || isClosed === 1 || isLock > 0}>
                            <i className="icofont-plus" aria-hidden="true">Add Text</i>
                        </button>
                        {(assignedModules.has(MODULE_IDS.Invoices) &&
                            <button style={{ "marginLeft": "5px" }} type="button" className={`btn btn-warning ${isLock > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={(event) => handleCreateInvoice(event, AgreementID)} disabled={isClosed === '1' || isClosed === 1 || AgreementID === '0' || AgreementID === 0 || isLock > 0 || !assignedModules.has(MODULE_IDS.Invoices)}>
                                <img style={{ "width": "10px" }} src="assets/img/icons/btnIssuesD.png" alt="Add icon" /> Invoice
                            </button>
                        )}
                        <button style={{ "marginLeft": "5px", background: "#388E3C" }} type="button" className={`btn btn-dark ${isLock > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={(event) => handleRenewAgreement(event, AgreementID)} disabled={AgreementID === '0' || isLock > 0 || AgreementID === 0}>
                            <img style={{ "width": "10px" }} src="assets/img/icons/sale.png" alt="Add icon" />  Renew
                        </button>

                    </div>
                    <div className="col-sm-4" >
                        <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                        </button>
                        <button type="submit" className={`btn btn-primary ${isLock > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "float": "right", "marginLeft": "5px" }} disabled={isClosed === '1' || isClosed === 1 || isLock > 0}>
                            <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                            {AgreementID > 0 ? ' Update' : ' Save'}

                        </button>
                        <button style={{ "marginLeft": "5px", "float": "right" }} type="button" className="btn btn-secondary" onClick={generatePDF}>
                            <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                        </button>

                    </div>
                </div>
            </form>
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}
            {(showDescriptionModal &&
                <DescriptionModal
                    show={showDescriptionModal}
                    text={descriptionText}
                    position={modalPosition}
                />
            )}
            <PartSelectionModal
                show={showPartModal}
                onClose={() => setShowPartModal(false)}
                parts={partList}
                onSelectPart={handlePartSelect}
                ClientCompanyID={formData.CustomerID}
            />
            <CustomerSelectionModal
                show={showCustomerModal}
                onClose={() => setShowCustomerModal(false)}
                customers={CustomerList}
                onSelectCustomer={handleCustomerSelect}
            />

        </div>


    );
}
export default AgreementDetail;

